import { AppNavigationInfo } from './_types';

export const getNavigationConfig = (): Record<string, AppNavigationInfo> => {
    const p = useAppPermissions();
    return {
        home: {
            title: 'navigation.home.title',
            to: { name: 'index' },
            icon: 'las la-home',
        },
        notifications: {
            title: 'navigation.notifications.title',
            to: { name: 'notifications' },
            custom: true,
        },
        orders: {
            title: 'navigation.orders.title',
            to: { name: 'orders' },
            can: p.canShowOrders,
        },
        demands: {
            title: 'navigation.demands.title',
            to: { name: 'demands' },
            can: p.canShowDemands,
        },
        'service-calls': {
            title: 'navigation.serviceCalls.title',
            to: { name: 'service-calls' },
            can: p.canShowServiceCalls,
        },
        documents: {
            title: 'navigation.documents.title',
            to: { name: 'documents' },
            can: p.canShowDocuments,
        },
        invoices: {
            title: 'navigation.invoices.title',
            to: { name: 'invoices' },
            can: p.canShowInvoices,
        },
        deliveryLists: {
            title: 'navigation.deliveryLists.title',
            to: { name: 'delivery-lists' },
            can: p.canShowDeliveryLists,
        },
        settings: {
            title: 'navigation.settings.title',
            to: { name: '' },
            icon: 'las la-cog',
            children: [
                {
                    title: 'navigation.settings.profile.title',
                    to: { name: 'profile' },
                    icon: undefined,
                },
                {
                    title: 'navigation.settings.admin.title',
                    to: { name: 'admin' },
                    icon: undefined,
                    can: p.canManageApp,
                    children: [
                        {
                            title: 'navigation.settings.admin.partners.title',
                            subtitle: 'navigation.settings.admin.partners.subtitle',
                            to: { name: 'admin-partners' },
                            can: p.canManagePartners,
                        },
                        {
                            title: 'navigation.settings.admin.users.title',
                            subtitle: 'navigation.settings.admin.users.subtitle',
                            to: { name: 'admin-users' },
                            can: p.canManageUsers,
                        },
                        {
                            title: 'navigation.settings.admin.files.title',
                            subtitle: 'navigation.settings.admin.files.subtitle',
                            to: { name: 'admin-documents' },
                            can: p.canManageDocuments,
                        },
                        {
                            title: 'navigation.settings.admin.translations.title',
                            subtitle: 'navigation.settings.admin.translations.subtitle',
                            to: { name: 'admin-translations' },
                            can: p.canManageDials,
                        },
                        {
                            title: 'navigation.settings.admin.categories.title',
                            subtitle: 'navigation.settings.admin.categories.subtitle',
                            to: { name: 'admin-categories' },
                            can: p.canManageDials,
                        },
                    ],
                },
            ],
        },
    };
};
